import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'fc-cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.less'],
    standalone: false
})
export class CartComponent {
    @Input() type: CartType;
    @Output() onOrderSent = new EventEmitter<void>();
}

export enum CartType {
    ShoppingCart = 'shopping-cart',
    DownloadCart = 'download-cart',
    OrderSheet = 'order-sheet',
    MainContentDrawer = 'main-content-drawer'
}
